import { StyleSheet, Platform, Dimensions } from 'react-native'

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    justifyContent: 'center',
    // marginBottom: 10,
    backgroundColor: theme.colors.backgroundColor,
    paddingTop: 6,
    paddingBottom: 12
  }),
  mainCardStyle: {
    flex: 1,
    alignSelf: 'center',
  },
  secondaryCardsContainerStyle: {
    flex: 1,
    flexDirection: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'column' : 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 17,
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 15,
    maxHeight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 500 : 350,
  },
  addMoreContainersStyle: {
    justifyContent: 'space-between',
    marginLeft: 12,
  },
  fourthComponentCard: {
    marginTop: 13,
  },
  marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 20 : null,
  alignItems: 'center',
  flexDirection: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'row' : 'column',
  desktopContainerStyle: (theme) => ({
    flex: 1,
    justifyContent: 'space-between',
    paddingBottom: 20,
    paddingTop: 50,
    flexDirection: 'row',
    backgroundColor: theme.colors.backgroundColor
  })
})
